import { render, staticRenderFns } from "./detail-tips.vue?vue&type=template&id=6c314dc7&scoped=true"
import script from "./detail-tips.vue?vue&type=script&lang=js"
export * from "./detail-tips.vue?vue&type=script&lang=js"
import style0 from "./detail-tips.vue?vue&type=style&index=0&id=6c314dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c314dc7",
  null
  
)

export default component.exports